// extracted by mini-css-extract-plugin
export default {"profIco":"acc_profIco__kcP1g","profLetter":"acc_profLetter__ZFWcF","profAccWrap":"acc_profAccWrap__jYH7V","navL":"acc_navL__UqFI6"};